import React from 'react';
import {
  ProgressBarItem, ProgressBarContainer,
  ArrowDivContainer, ProgressBarArrowContainer,
  BadgeBottomText, BadgeItem,
  BadgeItemContainer, BadgesContainer,
  BadgeTopButton, ProgressBarDesktopContainer, GiftBadgeContainer, GiftBadgeItem, GiftIcon, GiftDescription
} from './ProgressBarStyle';
import { IContent } from '../../../../types';
import { withContent } from '../../../../hoc/withContext';
import { ReactComponent as ProgressBarArrow } from '../../../../assets/progress_bar_arrow.svg';
import { IBadgeItem } from '../../../../types/content';
import { getGiftBadges } from '../../../../utils/Functions';
import Fade from 'react-reveal/Fade';
import Image from '../../../../utils/Image/Image';

interface IProgressBarProps {
  previousLoadPercentage: number;
  newLoadPercentage: number;
  currentBadge: number;
  badgeClick: (loadPercentage: string, index: number, animationPass?: boolean) => void;
  context?: IContent;
}

const ProgressBar = ({ previousLoadPercentage, newLoadPercentage, currentBadge, badgeClick, context }: IProgressBarProps) => {
  return (
    <ProgressBarDesktopContainer>
      {/*Top badges Start*/}
      <BadgesContainer>
        {context.rewardBadge.badge.map((badgeItem: IBadgeItem, index) => {
          let currentHighlight = currentBadge === index;
          return (
              <BadgeItemContainer onClick={() => badgeClick(badgeItem.loadPercentage, index, true)}
                                  key={badgeItem.image}>
                <BadgeTopButton highlightedBadge={currentHighlight} >{badgeItem.month}</BadgeTopButton>
                <BadgeItem highlightedBadge={currentHighlight}>
                  <Image
                    imageName={badgeItem.image}
                    altText={badgeItem.image}
                    extension='png'
                  />
                </BadgeItem>
                <BadgeBottomText highlightedBadge={currentHighlight}>{badgeItem.badgeText}</BadgeBottomText>

              </BadgeItemContainer>
           );
        })}
      </BadgesContainer>
      {/*Top badges End*/}
      {/*Progress bar Start*/}
        <ProgressBarContainer>
          <ProgressBarItem previousWidth={previousLoadPercentage} newWidth={newLoadPercentage} />
          <ArrowDivContainer>
            <ProgressBarArrowContainer><ProgressBarArrow /></ProgressBarArrowContainer>
            <ProgressBarArrowContainer><ProgressBarArrow /></ProgressBarArrowContainer>
            <ProgressBarArrowContainer><ProgressBarArrow /></ProgressBarArrowContainer>
          </ArrowDivContainer>
        </ProgressBarContainer>
      {/*Progress bar End*/}
      {/*Bottom gift icons Start*/}
      <GiftBadgeContainer>
        {context.rewardBadge.badge.map((badge: IBadgeItem, index) => {
          let delay = currentBadge === index ? 300 : 0;
          return <GiftBadgeItem  key={'badge' + index}>
            <Fade distance={'20px'} opposite left when={currentBadge === index} delay={delay} duration={750}>
              <GiftIcon>{getGiftBadges(index + 1)}</GiftIcon>
            </Fade>
            {/*Two description used to have a different cta singular text when there is only 1 reward*/}
            <Fade distance={'20px'} opposite left when={currentBadge === index} delay={delay} duration={750}>
              <GiftDescription dangerouslySetInnerHTML={{
                __html: `<b>${(index + 1).toString()}</b>  ${index === 0 ? context.rewardBadge.giftBadgeSingleDescription :
                  context.rewardBadge.giftBadgeDescription}`
              }} />
            </Fade>
          </GiftBadgeItem>;
        })}
      </GiftBadgeContainer>
      {/*Bottom gift icons end*/}
    </ProgressBarDesktopContainer>
  );
};

export default withContent(ProgressBar);